module.exports = __webpack_public_path__ + "media/images/front/program_notify-2e0fb5d81d9a9b3865df957e55230c42.jpg";